import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { HomePath } from '../home-path'

export default function Locations() {
  if (!localStorage.getItem('reloadGN')) {
    localStorage.setItem('reloadGN', 'true');
    window.location.reload();
}
    
  return (
    <div className="h-fit w-full py-12">
        <div className="mxw h-full flex flex-col items-center justify-around">
            <div className="pt-72">
                <div className="w-full flex justify-center py-4">
                  <div className="h-12 w-12 border border-gray-700 rounded-full grid place-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                  </svg>
                  </div>
                </div>
                <p className="py-4 text-center">Enable your location to see nearby stores or search to find a store.</p>
            </div>
            <div className="max-w-4xl w-full space-y-4">
                <a href={HomePath + "/all-locations"} target="_blank" rel="noreferrer noopener">
                <button className="w-full py-3 px-4 rounded-3xl block bg-[#0e0e0e] text-white">
                  Enable location
                </button>
                </a>
                <button className="w-full py-3 px-4 rounded-3xl block bg-gray-200 text-black">Search</button>
            </div>
        </div>
    </div>
  )
}
